import { Box } from '@material-ui/core';
import { Kyc } from '@nemuru-eng/js-api-client';

import { CheckResult } from '@/components/shared/components/CheckResult/CheckResult';

import { Font } from '../../../../../../../shared/components/Font';
import { Text } from '../../../../../../../shared/components/Text';

interface KycSecurityCheckListProps {
  securityChecks: Kyc['securityChecks'];
}

export const KycSecurityCheckList = ({ securityChecks }: KycSecurityCheckListProps) => {
  return (
    <>
      <Box pb={2}>
        <Font variant={'subtitle1'} color={'title'}>
          <Text strong tId={'AUTOMATIC_SECURITY_CHECKS'} />
        </Font>
      </Box>
      {securityChecks.map((check, key) => (
        <CheckResult key={key} check={check} />
      ))}
    </>
  );
};
